'use client';

import { createContext, useContext, ReactNode, JSX } from 'react';

interface DigitalWalletsContextType {
    isDigitalWalletsEnabled: boolean;
}

export const DigitalWalletsContext = createContext<DigitalWalletsContextType | undefined>(undefined);

export const DigitalWalletsProvider = ({
    children,
    isDigitalWalletsEnabled,
}: {
    children: ReactNode;
    isDigitalWalletsEnabled: boolean;
}): JSX.Element => {
    return (
        <DigitalWalletsContext.Provider value={{ isDigitalWalletsEnabled }}>{children}</DigitalWalletsContext.Provider>
    );
};

export const useDigitalWallets = (): DigitalWalletsContextType => {
    const context = useContext(DigitalWalletsContext);
    if (context === undefined) {
        throw new Error('useDigitalWallets must be used within a DigitalWalletsProvider');
    }
    return context;
};
